export default __webpack_public_path__ + "static/gold-dolphin-9f6a3833da2d7160afc6663f38ce73f7.jpg";